import React from 'react'
import '../../stylesheets/RefSS.css'
function References({ sources }) {

  return (
    <div id='ref_container'>
      <fieldset>
        <legend>Sources</legend>
        {sources.map((source, index) => {
          if (source.link.length === 0) {
            return (
              <a key={index} href={source.link}>{source.name};</a>
            )
          }
          return(
            <a key={index} href={source.link} target="__blank">{source.name};</a>
          )

        })}
      </fieldset>
    </div>
  )
}

export default References